module.exports = __webpack_public_path__ + "static/media/slider-right.6f70fae3.png";